import React from "react";
import styles from "./workspace.module.css";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export const Workspace = () => {

  return (
    <Box className={styles.workspace}>
      <Outlet />
    </Box>
  );
};
